import React from 'react';
import { Form, theme } from 'antd';
import { useTranslation } from 'react-i18next';
import { StructuredNoteField } from '@/components/structured-note';

interface NotesFieldProps {
  required?: boolean;
}

export const NotesField: React.FC<NotesFieldProps> = ({ required = false }) => {
  const { token } = theme.useToken();
  const { t } = useTranslation('manage');

  return (
    <>
      <style>
        {`
          .structured-note-form-item .structured-note-form-extra {
            display: block;
            margin-top: ${token.marginSM}px;
          }
        `}
      </style>
      <Form.Item
        className="structured-note-form-item"
        label={t('appointmentComponents.create.notes.label')}
        name="notes"
        rules={
          required
            ? [{ required: true, message: t('appointmentComponents.create.notes.required') }]
            : undefined
        }
      >
        <StructuredNoteField
          rows={5}
          placeholder={t('appointmentComponents.create.notes.placeholder')}
          showCount
          maxLength={4000}
        />
      </Form.Item>
    </>
  );
};
